import { Component, computed, input, OnInit } from '@angular/core';
import { NewRequestForm } from '../../../../components/user-dashboard-component/pharmacies/new-request-form/new-request-form';
import { PharmacyVTO } from '../../../../services/pharmacy/pharmacy.model';

@Component({
  selector: 'app-new-request',
  imports: [NewRequestForm],
  templateUrl: './new-request.html',
  styleUrl: './new-request.scss',
})
export class NewRequest {
  type = input<'create' | 'edit' | undefined>('create');
  pharmacyData = input<PharmacyVTO | undefined>();
  resolvedType = computed(() => this.type() ?? 'create');
}
